// src/utils/services/Patients/getPatientMembership.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/PatientInfo/Membership`;

function tryParseJson(maybeJson) {
  if (typeof maybeJson !== "string") return maybeJson;
  const s = maybeJson.trim();
  if (!s) return maybeJson;

  // intenta parsear si parece JSON
  if ((s.startsWith("{") && s.endsWith("}")) || (s.startsWith("[") && s.endsWith("]"))) {
    try {
      return JSON.parse(s);
    } catch {
      return maybeJson;
    }
  }
  return maybeJson;
}

export const getPatientMembership = async (cipId) => {
  const normalized = String(cipId ?? "").trim();
  try {
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "application/json", // ✅ clave
      },
      params: {
        cipId: normalized || null, // ✅ query param correcto según swagger
      },
      // por si el server insiste en text/plain
      transformResponse: [
        (data) => {
          const parsed = tryParseJson(data);
          return parsed;
        },
      ],
    });

    return response.data;
  } catch (error) {
    console.error("[getPatientMembership] Error:", error);
    throw error;
  }
};
